import React from 'react';
import { Modal, Card, Badge } from 'antd';

const ModalVariantes = ({ isModalVariantesOpen, setIsModalVariantesOpen, productoParaVariantes, procesarSeleccionProducto  }) => {
    return (
        <Modal
            title={<span style={{ fontSize: '18px' }}>Seleccionar Presentación</span>}
            open={isModalVariantesOpen}
            onCancel={() => setIsModalVariantesOpen(false)}
            footer={null}
            centered
        >
            {productoParaVariantes && (
                <div>
                    <p style={{ marginBottom: '15px', color: '#64748b' }}>
                        Elige una opción para <strong>{productoParaVariantes.nombre}</strong>:
                    </p>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                        {productoParaVariantes.variantes.map(v => (
                            <Card
                                key={v.id}
                                hoverable
                                onClick={() => {
                                    procesarSeleccionProducto(productoParaVariantes, v);
                                }}
                                style={{ borderColor: v.stock > 0 ? '#1890ff' : '#f5f5f5', opacity: v.stock > 0 ? 1 : 0.6 }}
                                bodyStyle={{ padding: '15px', textAlign: 'center' }}
                            >
                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1e293b' }}>
                                    {v.atributos?.nombre || 'Variante'}
                                </div>
                                <div style={{ color: '#22BABB', fontWeight: 'bold', marginTop: '5px' }}>
                                    ${Number(v.precio_base || productoParaVariantes.precio_venta).toLocaleString('es-CO')}
                                </div>
                                <Badge
                                    count={`${v.stock} en stock`}
                                    color="#52c41a"
                                    style={{ marginTop: '8px' }}
                                />
                            </Card>
                        ))}
                    </div>
                </div>
            )}
        </Modal>
    )
}

export default ModalVariantes;